export class ClassVehicle {
  direction(v) {
    switch (v) {
      case 'Forward': return 'Прямий'
      case 'Backward': return 'Зворотній'
      default: return '-'
    }
  }

  distance(v) {
    return v != null ? `${(v).toFixed(1)} км.` : '-'
  }

  nextNumber(v) {
    return v && v != null ? v.nextVehicleNumber : '-'
  }

  previousNumber(v) {
    return v && v != null ? v.previousVehicleNumber : '-'
  }

  speed(v) {
    let speed = v != null ? v : 0
    return `${speed} км/год`
  }

  debugInfo(v) {
    let data = v && v != null ? v.debugInfo : '-'
    data = data.split(';').join('<br>')
    return data
  }
}

export const filterOnlyCarsWithCoords = (cars) => {
  if (Array.isArray(cars) && cars.length != 0) {
    const validTypeof = (i) => typeof i.lat === 'number' && typeof i.lon === 'number'
    const validCoords = (i) => i.lat != 0 && i.lon != 0

    return cars.filter(i => validTypeof(i) && validCoords(i))
  } else { return [] }
}

export const carsUpdateItemsByAzimuth = (new_list, old_list) => {
  let result = []

  for (let new_car of new_list) {
    let old_car = old_list.find(k => k.number == new_car.number)
    // Если новой машины нет в текущем списке, добавляем
    if (old_car === undefined) {
      result.push(new_car)
    } else {
      // Если есть, проверяем скорость у новой машины
      if (new_car.speed == 0) {
        // Если 0, присвоим старый азимут
        let obj = { ...new_car }
        obj.azimuth = old_car.azimuth
        result.push(obj)
      } else {
        // Скорость не 0, просто добавляем новую машины в массив
        result.push(new_car)
      }
    }
  }

  return [...result]
}

export const colorCarByRoute = (dtransport_id = { dtransport_id: null }, routes_list = []) => {
  let result = routes_list.find(i => i.dtransport_id == dtransport_id)
  return result !== undefined ? result.color : `#999`
}

export const addColorCarsByRoute = (cars = [], routes = [], colorFn = colorCarByRoute) => {
  return cars.map(i => {
    return {
      ...i,
      color: colorFn(i.dtransport_id, routes)
    }
  })
}